const THREEMIN = 3 * 60 * 1000;
const FIVEMIN = 5 * 60 * 1000;

const COLOR_OK = 'green';
const COLOR_WARNING = 'yellow';
const COLOR_ALERT = 'red';

/**
 * Возвращает цвет маркера на карте в зависимости от давности даты.
 * - < 3 минут: 'green'
 * - < 5 минут: 'yellow'
 * - >= 5 минут: 'red'
 * @param {string|Date} date - Дата/время последнего обновления.
 * @returns {string} Цвет маркера ('green' | 'yellow' | 'red').
 */
const calculateMarkerColor = (date) => {
  if (!date) return COLOR_ALERT;

  const now = Date.now();
  const diff = now - new Date(date).getTime();

  return diff < THREEMIN ? COLOR_OK : diff < FIVEMIN ? COLOR_WARNING : COLOR_ALERT;
};

export default calculateMarkerColor;
